export const environment = {
  production: true,
  envName: 'prd',
  spa: {
    baseUrl: '/webapps',
    app: {
      cache: '/cache',
      res: '/reservation',
      srv: '/servicing',
      exc: '/exchange',
      cki: '/checkin',
    },
  },
  api: {
    baseUrl: 'https://space.ana.co.jp',
    clientId: 'd4df2b8bcfdc47cc9005bde719f3e9c0',
    clientSecret: 'BeBb2FE567eb400e8C70145F6ad4D5d0',
    app: {
      sysdate: '/sysdate/api/v1',
      authorization: '/aswbe-authorization/api/v1',
      initialization: '/aswbe-initialization/api/v1',
      user: '/aswbe-user/api/v1',
      amcmember: '/aswbe-amcmember/api/v1',
      search: '/aswbe-search/api/v1',
      reservation: '/aswbe-reservation/api/v1',
      servicing: '/aswbe-servicing/api/v1',
      exchange: '/aswbe-exchange/api/v1',
      checkin: '/aswbe-checkin/api/v1',
    },
    s1Intercept: {
      disable: true,
      replaceWith: 'http://localhost:8888',
      pathMatcher: [],
    },
  },
  datadog: {
    disable: false,
    env: 'prd',
    clientToken: 'pub71ef99b3ce6dfa6584aae68f6452919e',
    versionFileRelativeUrl: '',
  },
  tealium: {
    disable: false,
    url: 'https://www.ana.co.jp/common/js/sitecatalyst/general_tag_intbe.js',
  },
  dynatrace: {
    res: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/f5d765aaa3cd5493_complete.js',
    },
    srv: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/9efc65f8ebb25eb8_complete.js',
    },
    exc: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/6f3e784b52ad7d98_complete.js',
    },
    cki: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/482aad77bdc36dc5_complete.js',
    },
  },
  ensighten: {
    url: '//nexus.ensighten.com/uw-ana/prod/Bootstrap.js',
  },
};
